import translate from '@/services/translate';
import { localeCompareFor } from '@/services/sortHelper';
/**
 * Constrói a configuração para um select com opções baseadas em enum.
 * @param {Object|Array} enumDefinition Definição do enum. Pode ser uma constante de enum, ou
 * ou array de valores de enum.
 * @param {String} translationPath Caminho de tradução do enum. Dentro deste caminho,
 * devem haver as chaves de tradução de cada valor do enum.
 * @param {Boolean} [includeSelectOption=true] Incluir a opção "Selecione" no select.
 * Opicional, padrão true.
 * @param {String} [selectOptionTranslation=general.select] Texto a ser apresentado na opção null.
 * @param {Boolean} [sort=true] Ordenar opções em ordem alfabética. Opcional, padrão true.
 * @param {Boolean} [forMultiSelect=false] Define a configuração para componente de
 * multi-select. Opcional, padrão false.
 * @param {String} [valueField=id] Configura o nome do campo que carrega o identificador.
 * Opcional, padrão "id".
 * @param {String} [textField=name] Configura o nome do campo que carrega a descrição.
 * Opcional, padrão "name".
 */
export default ({
  enumDefinition,
  translationPath,
  includeSelectOption = true,
  selectOptionTranslation = 'general.select',
  sort = true,
  valueField = 'id',
  textField = 'name',
  forMultiSelect = false,
}) => {
  if (enumDefinition == null) {
    throw new Error('O parametro "enumDefinition" deve ser definido');
  }
  if (translationPath == null) {
    throw new Error('O parametro "translationPath" deve ser definido');
  }

  const enumValues = Array.isArray(enumDefinition) ? enumDefinition : Object.values(enumDefinition);
  const options = enumValues.map(enumValue => ({
    [valueField]: enumValue,
    [textField]: translate(`${translationPath}.${enumValue}`),
  }));

  if (sort) {
    options.sort(localeCompareFor(textField));
  }

  if (includeSelectOption) {
    options.unshift({
      [valueField]: null,
      [textField]: translate(selectOptionTranslation),
    });
  }

  return {
    options,
    ...!forMultiSelect
      ? {
        valueField,
        textField,
      }
      : {
        trackBy: valueField,
        label: textField,
      },
  };
};
